/* Mantiene al día «te faltan S/ X para el envío gratis».

   POR QUÉ HACE FALTA JAVASCRIPT PARA ALGO QUE YA SE PINTÓ EN EL SERVIDOR. Porque el
   carrito de Sense es AJAX: `cart_type` es `notification`, así que añadir un producto NO
   recarga la página. El número del servidor es correcto al cargar y se congela justo en el
   instante en que empieza a importar — un contador que sigue diciendo «te faltan S/ 32»
   después de que el cliente haya metido esos S/ 32 es peor que no tener contador, porque
   ya no es una ayuda sino un error visible.

   POR QUÉ ENVOLVIENDO `fetch` Y NO ESCUCHANDO A SENSE. Sense publica sus cambios de
   carrito en un bus interno (`PUB_SUB_EVENTS`) que no es API pública y que cambia entre
   versiones del tema; engancharse ahí es firmar que la próxima actualización lo rompa en
   silencio. `/cart/add` en cambio es la API de Shopify: lleva años estable y la usa
   cualquier tema. Sondear con un temporizador se descartó por lo obvio — gastar batería en
   un móvil para no enterarse de nada el 99 % de las veces.

   SI ALGO DE ESTO FALLA no pasa nada grave: el número se queda en el que pintó el
   servidor, que era correcto al cargar. Se degrada hacia lo que había antes, no hacia un
   hueco. */
(function () {
  var caja = document.querySelector('[data-mibi-envio]');
  if (!caja || typeof window.fetch !== 'function') return;

  var texto = caja.querySelector('[data-mibi-envio-texto]');
  var barra = caja.querySelector('[data-mibi-envio-barra]');
  var umbral = parseInt(caja.getAttribute('data-umbral'), 10) || 0;
  var zona = caja.getAttribute('data-zona') || '';
  var formato = caja.getAttribute('data-formato') || 'S/ {{amount}}';
  if (!umbral) return;

  function plata(centimos) {
    /* Se respeta el `money_format` de la tienda en vez de escribir «S/ » a mano: el día
       que Chávez cambie la divisa o el separador, esto lo sigue. Sólo se soportan los dos
       marcadores que Shopify usa en la práctica; cualquier otro cae al importe pelado, que
       es feo pero no es falso. */
    var v = (centimos / 100).toFixed(2);
    if (formato.indexOf('amount_with_comma_separator') !== -1) {
      v = v.replace('.', ',');
    }
    var salida = formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
    return salida === formato ? v : salida;
  }

  function pintar(total) {
    var falta = umbral - total;
    if (falta <= 0) {
      texto.innerHTML = 'Tu pedido ya tiene <strong>envío gratis</strong> en ' + zona + '.';
    } else {
      texto.innerHTML = 'Te faltan <strong>' + plata(falta) +
                        '</strong> para el envío gratis en ' + zona + '.';
    }
    var pct = Math.min(100, Math.round((total * 100) / umbral));
    if (barra) barra.style.width = pct + '%';
  }

  function refrescar() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === 'number') pintar(c.total_price); })
      .catch(function () { /* se queda el valor del servidor */ });
  }

  var original = window.fetch;
  window.fetch = function () {
    var salida = original.apply(this, arguments);
    try {
      var url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        /* Se espera a que la respuesta termine: preguntar por el carrito antes de que
           Shopify haya confirmado el cambio devuelve el total viejo, y entonces el
           contador parpadea al número equivocado y vuelve. */
        salida.then(refrescar, function () {});
      }
    } catch (e) { /* nunca romper el fetch de otro */ }
    return salida;
  };
})();
